import useScreenSize from 'hooks/useScreenSize';
import PhotoSquare from 'icons/PhotoSquare';
import { Fragment, MouseEvent, useState } from 'react';
import { usePhotoGalleryContainer } from '..';
import styles from './styles/PhotoGalleryThumbnails.module.scss';
import Image from 'components/Image';
import MinuteMediaAd, { MinuteMediaPlacementType } from '@/components/ads/MinuteMediaAd';
const adSlotsSmall = [3, 8];
const adSlotsLarge = [3, 9];
const adSlots: { [index: number]: MinuteMediaPlacementType } = { 3: 'IN_FEED', 8: 'IN_FEED_2', 9: 'IN_FEED_2' };

export const PREVENT_DEFAULT = (e: MouseEvent<HTMLDivElement | HTMLImageElement>) => e.preventDefault();

export default function PhotoGalleryThumbnails() {
  const [{ photoGallery, photoSlides }, { handleThumbnailClick }] = usePhotoGalleryContainer();
  const [hoveredIndex, setHoveredIndex] = useState<Number>();
  const { isSmallScreen } = useScreenSize();
  const adSlotIndexes = isSmallScreen ? adSlotsSmall : adSlotsLarge;
  return (
    <div className={styles.ThumbnailGrid} onContextMenu={PREVENT_DEFAULT}>
      {photoGallery &&
        photoGallery.photos.map((image, index) => (
          <Fragment key={`photo-thumbnail-${index}`}>
            {adSlotIndexes.includes(index) && <MinuteMediaAd placement={adSlots[index]} className={styles.AdFullWidth} />}
            <div
              className={styles.ThumbnailContainer}
              onClick={() => handleThumbnailClick(index)}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(undefined)}
            >
              <Image src={image.watermark} alt={image.filename} className={styles.ThumbnailImage} />
              {hoveredIndex === index && !isSmallScreen && (
                <div className={styles.IconOverlay}>
                  <PhotoSquare />
                </div>
              )}
            </div>
          </Fragment>
        ))}
    </div>
  );
}
